export const cartLevel = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g data-name="Mask Group 59">
      <g data-name="svgexport-6 (49)" fill="#6a6f73">
        <path
          data-name="Path 5412"
          d="M8 14.865a.625.625 0 0 0 .637-.637V7.31a2.239 2.239 0 0 0 0-4.286V1.772a.637.637 0 1 0-1.273 0v1.252a2.239 2.239 0 0 0 0 4.286v6.918a.625.625 0 0 0 .636.637Zm-.955-9.7A.955.955 0 1 1 8 6.12a.951.951 0 0 1-.954-.953Z"
        />
        <path
          data-name="Path 5413"
          d="M2.228 14.865a.625.625 0 0 0 .637-.637v-.912a2.239 2.239 0 0 0 0-4.286V1.772a.625.625 0 0 0-.637-.637.625.625 0 0 0-.637.637V9.05a2.239 2.239 0 0 0 0 4.286v.912a.634.634 0 0 0 .637.617Zm-.955-3.671a.955.955 0 1 1 .955.955.951.951 0 0 1-.955-.955Z"
        />
        <path
          data-name="Path 5414"
          d="M13.772 14.865a.625.625 0 0 0 .637-.637v-2.1a2.239 2.239 0 0 0 0-4.286v-6.07a.637.637 0 0 0-1.273 0v6.069a2.239 2.239 0 0 0 0 4.286v2.1a.625.625 0 0 0 .636.638Zm-.955-4.881a.955.955 0 1 1 .955.955.951.951 0 0 1-.955-.955Z"
        />
      </g>
    </g>
  </svg>
);

export const cartDuration = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g data-name="Mask Group 60">
      <g data-name="svgexport-6 (50)" fill="#6a6f73">
        <path
          data-name="Path 5415"
          d="M7.637 3.269a.727.727 0 0 0-.727.727v4.366a.727.727 0 0 0 .727.727h3.273a.728.728 0 1 0 0-1.455H8.365V3.997a.727.727 0 0 0-.728-.728Z"
        />
        <path
          data-name="Path 5416"
          d="M13.658 2.34a8.011 8.011 0 0 0-11.316 0 .727.727 0 1 0 1.029 1.028 6.547 6.547 0 1 1 .934 10.024l.649-.215a.728.728 0 0 0-.46-1.38l-1.886.629a.728.728 0 0 0-.486.819l.388 2.158a.728.728 0 0 0 .715.6.737.737 0 0 0 .13-.012.727.727 0 0 0 .587-.845l-.052-.291A8 8 0 0 0 13.658 2.34Z"
        />
        <path
          data-name="Path 5417"
          d="M1.772 4.166a.727.727 0 0 0-.973.335q-.091.185-.166.365a.727.727 0 1 0 1.339.568c.043-.1.087-.2.135-.3a.727.727 0 0 0-.335-.968Z"
        />
        <path
          data-name="Path 5418"
          d="M.729 8.548a.727.727 0 0 0 .727-.709q.005-.206.023-.412A.728.728 0 0 0 .029 7.3q-.022.25-.028.5a.727.727 0 0 0 .708.746h.019Z"
        />
        <path
          data-name="Path 5419"
          d="M1.725 9.867a.728.728 0 1 0-1.394.417c.038.127.079.255.124.381a.727.727 0 1 0 1.372-.483q-.055-.157-.102-.315Z"
        />
      </g>
    </g>
  </svg>
);

export const cartAccess = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g data-name="Mask Group 65">
      <g data-name="svgexport-6 (56)">
        <g data-name="Group 1393">
          <g data-name="Group 1392">
            <path
              data-name="Path 5435"
              d="M14.92 4.979A3.833 3.833 0 0 0 12 3.688a4.21 4.21 0 0 0-3.227 1.719A10.378 10.378 0 0 1 9.439 6.6 3.306 3.306 0 0 1 12 4.938 2.823 2.823 0 0 1 14.75 8 2.823 2.823 0 0 1 12 11.063c-2.278 0-3.4-3.229-3.407-3.261v-.009C8.531 7.625 7.11 3.688 4 3.688a3.833 3.833 0 0 0-2.92 1.291A4.539 4.539 0 0 0 0 8a4.539 4.539 0 0 0 1.08 3.021A3.833 3.833 0 0 0 4 12.313a4.189 4.189 0 0 0 3.226-1.686 9.949 9.949 0 0 1-.663-1.2A3.267 3.267 0 0 1 4 11.063 2.823 2.823 0 0 1 1.25 8 2.823 2.823 0 0 1 4 4.938c2.2 0 3.372 3.165 3.41 3.268.083.245 1.445 4.107 4.59 4.107a3.833 3.833 0 0 0 2.92-1.291A4.539 4.539 0 0 0 16 8a4.539 4.539 0 0 0-1.08-3.021Z"
              fill="#6a6f73"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const cartArticles = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g data-name="Mask Group 63">
      <g data-name="svgexport-6 (54)">
        <g data-name="Layer 9">
          <path
            data-name="Path 5427"
            d="M14.286 4.414v9.874a1.714 1.714 0 0 1-1.714 1.714H3.429a1.714 1.714 0 0 1-1.714-1.714V1.714A1.714 1.714 0 0 1 3.429 0h6.891a1.714 1.714 0 0 1 1.32.617l2.246 2.7a1.714 1.714 0 0 1 .4 1.1Zm-3.429-2.951v1.394a.571.571 0 0 0 .571.571h1.063Zm2.286 3.109h-1.714a1.714 1.714 0 0 1-1.714-1.714V1.143H3.429a.571.571 0 0 0-.572.571v12.571a.571.571 0 0 0 .571.571h9.143a.571.571 0 0 0 .571-.571Z"
            fill="#6a6f73"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const cartLectures = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g data-name="Mask Group 61">
      <g data-name="svgexport-6 (51)" fill="#6a6f73">
        <path
          data-name="Path 5420"
          d="M14.875 5.125A2.625 2.625 0 1 0 12.25 7.75a2.625 2.625 0 0 0 2.625-2.625ZM12.25 6.75a1.625 1.625 0 1 1 1.625-1.625A1.625 1.625 0 0 1 12.25 6.75Z"
        />
        <path
          data-name="Path 5421"
          d="M14.75 7.75h-4.164L7.627 6.563A1.007 1.007 0 0 0 6.66 8.3l2.994 2.2H1.5V1h10.75v.5a.5.5 0 0 0 1 0V1a.5.5 0 1 0 0-1H.5a.5.5 0 0 0 0 1v10a.5.5 0 0 0 .5.5h5.5v.587a1.5 1.5 0 1 0 1 0V11.5H10v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5V13h.25A1.251 1.251 0 0 0 16 11.75V9a1.251 1.251 0 0 0-1.25-1.25ZM7 14a.5.5 0 1 1 .5-.5.5.5 0 0 1-.5.5Zm8-2.25a.25.25 0 0 1-.25.25H12.5l1.708-.8a.5.5 0 0 0-.423-.906l-2.014.94A.925.925 0 0 0 12.166 13H13.5v2H11v-4.5a.5.5 0 0 0-.2-.4L7.255 7.491 10.3 8.714a.5.5 0 0 0 .186.036h4.264A.25.25 0 0 1 15 9Z"
        />
        <circle
          data-name="Ellipse 99"
          cx=".5"
          cy=".5"
          r=".5"
          transform="translate(2.5 8.5)"
        />
        <path
          data-name="Path 5422"
          d="M6 5.25a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0 0 1h2.5a.5.5 0 0 0 .5-.5Z"
        />
        <path
          data-name="Path 5423"
          d="M8.5 3.25a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5Z"
        />
      </g>
    </g>
  </svg>
);

export const cartQuizzes = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g data-name="Mask Group 64">
      <g data-name="svgexport-6 (55)">
        <g data-name="Group 1386" fill="#6a6f73">
          <path
            data-name="Path 5428"
            d="M14.472 8.532V.469A.469.469 0 0 0 14 0H4.191a.469.469 0 0 0-.469.469v12.219a.469.469 0 0 0 .469.469H7.8a4.218 4.218 0 1 0 6.676-4.625Zm-9.813 3.687V.938h8.875v7.005a4.233 4.233 0 0 0-5.946 4.276Zm7.125 2.844a3.281 3.281 0 1 1 3.281-3.281 3.285 3.285 0 0 1-3.281 3.281Z"
          />
          <path
            data-name="Path 5429"
            d="M1.409 1.531A1.408 1.408 0 0 0 0 2.938V10.5a.478.478 0 0 0 .038.185l.939 2.245a.47.47 0 0 0 .865 0l.936-2.246a.493.493 0 0 0 .032-.111.466.466 0 0 0 .006-.074V2.938a1.408 1.408 0 0 0-1.407-1.407Zm-.468 2.75h.938v5.75H.941Zm.469-1.812a.469.469 0 0 1 .469.469v.406H.941v-.406a.469.469 0 0 1 .468-.469Zm0 9.063-.234-.562h.469Z"
          />
          <path
            data-name="Path 5430"
            d="M6.066 2.813h6.062a.469.469 0 0 0 0-.937H6.066a.469.469 0 0 0 0 .937Z"
          />
          <path
            data-name="Path 5431"
            d="M6.066 4.688h6.062a.469.469 0 0 0 0-.938H6.066a.469.469 0 0 0 0 .938Z"
          />
          <path
            data-name="Path 5432"
            d="M6.066 6.563h6.062a.469.469 0 0 0 0-.937H6.066a.469.469 0 0 0 0 .938Z"
          />
          <path
            data-name="Path 5433"
            d="M8.026 7.969a.469.469 0 0 0-.469-.469H6.066a.469.469 0 0 0 0 .938h1.491a.469.469 0 0 0 .469-.469Z"
          />
          <path
            data-name="Path 5434"
            d="M13.544 10.287a.469.469 0 0 0-.658.08l-1.429 1.826-.584-.676a.469.469 0 1 0-.709.613l.957 1.107a.469.469 0 0 0 .724-.018l1.78-2.274a.469.469 0 0 0-.08-.658Z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const colorfulShareIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <g data-name="svgexport-6 (92)" transform="translate(1.906 6.998)">
      <path
        data-name="Path 10683"
        d="m3.082 2.001 8.893-4.713-.445-.815-9.734 5.068v.919l10.152 5.068.445-.815Z"
        fill="#c1cdd3"
      />
      <circle
        data-name="Ellipse 1831"
        cx="3.144"
        cy="3.144"
        r="3.144"
        transform="rotate(-67.486 1.82 3.279)"
        fill="#ffad39"
      />
      <path
        data-name="Path 10684"
        d="M5.343 1.985a3.144 3.144 0 0 1-5.85 1.6 3.144 3.144 0 0 0 5.1-2.461 3.112 3.112 0 0 0-.436-1.6 3.126 3.126 0 0 1 1.186 2.461Z"
        fill="#e68c15"
      />
      <circle
        data-name="Ellipse 1832"
        cx="2.984"
        cy="2.984"
        r="2.984"
        transform="rotate(-67.486 10.67 -1.85)"
        fill="#7e59d1"
      />
      <path
        data-name="Path 10685"
        d="M15.172 7.099a2.984 2.984 0 0 1-5.553 1.517 2.983 2.983 0 0 0 4.43-3.85 2.971 2.971 0 0 1 1.123 2.333Z"
        fill="#7859bc"
      />
      <circle
        data-name="Ellipse 1833"
        cx="2.984"
        cy="2.984"
        r="2.984"
        transform="rotate(-67.486 2.94 -6.804)"
        fill="#7e59d1"
      />
      <path
        data-name="Path 10686"
        d="M14.978-3.097A2.984 2.984 0 0 1 9.425-1.58a2.983 2.983 0 0 0 4.425-3.846 2.967 2.967 0 0 1 1.128 2.329Z"
        fill="#7859bc"
      />
    </g>
  </svg>
);

export const colorfulGiftIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <g data-name="Group 10738">
      <g data-name="Mask Group 453">
        <g data-name="svgexport-6 (87)">
          <g data-name="14-Gift">
            <path
              data-name="Path 10653"
              d="M11.326 6.968h5.226v9.871A1.161 1.161 0 0 1 15.391 18h-4.359V6.968Z"
              fill="#ffad39"
            />
            <path
              data-name="Path 10654"
              d="M6.968 6.968V18H2.613a1.161 1.161 0 0 1-1.161-1.161V6.968Z"
              fill="#ffad39"
            />
            <path
              data-name="Path 10655"
              d="M6.674 3.483v3.484H.58a.582.582 0 0 1-.581-.581V4.064a.582.582 0 0 1 .581-.581Z"
              fill="#febd55"
            />
            <path
              data-name="Path 10656"
              d="M18 4.064v2.323a.582.582 0 0 1-.581.581h-6.1V3.483h6.1a.582.582 0 0 1 .581.581Z"
              fill="#febd55"
            />
            <path
              data-name="Path 10657"
              d="M10.452 2.903v.581h-2.9v-.581a.582.582 0 0 1 .581-.581h1.738a.582.582 0 0 1 .581.581Z"
              fill="#8b68d8"
            />
            <path
              data-name="Path 10658"
              d="M9.871 2.903H8.129a.581.581 0 0 1-.5-.29.573.573 0 0 0-.081.29v.581h2.904v-.581a.573.573 0 0 0-.081-.29.581.581 0 0 1-.5.29Z"
              fill="#7e59d1"
            />
            <path
              data-name="Path 10659"
              d="M7.548 2.903v.581H3.19a.853.853 0 0 1-.871-.871c0-1.161 1.452-1.161 1.452-1.161a5.7 5.7 0 0 1 3.777 1.451Z"
              fill="#8b68d8"
            />
            <path
              data-name="Path 10660"
              d="M5.226 0c2.323 0 2.323 2.9 2.323 2.9a5.7 5.7 0 0 0-3.775-1.449A1.422 1.422 0 0 1 5.226 0Z"
              fill="#8b68d8"
            />
            <path
              data-name="Path 10661"
              d="M10.452 2.903s0-2.9 2.323-2.9a1.422 1.422 0 0 1 1.452 1.452 5.7 5.7 0 0 0-3.775 1.448Z"
              fill="#8b68d8"
            />
            <path
              data-name="Path 10662"
              d="M10.452 2.903a5.7 5.7 0 0 1 3.774-1.452s1.452 0 1.452 1.161a.853.853 0 0 1-.871.871h-4.355Z"
              fill="#8b68d8"
            />
            <path
              data-name="Path 10663"
              d="M6.968 6.968h4.065V18H6.968Z"
              fill="#7e59d1"
            />
            <path
              data-name="Path 10664"
              d="M11.323 3.483v3.484H6.677V3.483h4.645Z"
              fill="#7a57c9"
            />
            <path
              data-name="Path 10670"
              d="M16.549 8.129V6.968h-5.517v1.161Z"
              fill="#e68c15"
            />
            <path
              data-name="Path 10671"
              d="M15.387 16.839h-4.355V18h4.355a1.161 1.161 0 0 0 1.161-1.161v-1.162a1.161 1.161 0 0 1-1.161 1.162Z"
              fill="#e68c15"
            />
            <path
              data-name="Path 10672"
              d="M2.903 11.613V9.291a1.161 1.161 0 0 1 1.162-1.162h2.9V6.968H1.452v9.871A1.161 1.161 0 0 0 2.613 18h4.355v-1.3a5.226 5.226 0 0 1-4.065-5.087Z"
              fill="#e68c15"
            />
            <path
              data-name="Path 10673"
              d="M8.129 16.838a5.241 5.241 0 0 1-1.161-.134v1.3h4.065v-1.166Z"
              fill="#7455bb"
            />
            <path
              data-name="Path 10674"
              d="M6.968 6.968h4.065v1.161H6.968Z"
              fill="#7a57c9"
            />
            <path
              data-name="Path 10675"
              d="M3.048 5.516a1.016 1.016 0 0 1 0-2.032H.58a.582.582 0 0 0-.581.581v2.322a.582.582 0 0 0 .581.581h6.094V5.516Z"
              fill="#ffa930"
            />
            <path
              data-name="Path 10676"
              d="M17.419 5.516h-6.1v1.455h6.1A.582.582 0 0 0 18 6.39V4.936a.581.581 0 0 1-.581.58Z"
              fill="#ffa930"
            />
            <path
              data-name="Path 10677"
              d="M6.677 5.516v1.452h4.645V5.516Z"
              fill="#7e59d1"
            />
            <path
              data-name="Path 10678"
              d="M6.387 1.451a5.87 5.87 0 0 0-2.576-.3 1.726 1.726 0 0 0-.037.3 5.7 5.7 0 0 1 3.774 1.452A3.913 3.913 0 0 0 6.866.761c.001.368-.104.69-.479.69Z"
              fill="#7e59d1"
            />
            <path
              data-name="Path 10679"
              d="M11.903 1.451c-.482 0-.519-.533-.456-1.01a3.557 3.557 0 0 0-1 2.462 5.7 5.7 0 0 1 3.774-1.452 1.752 1.752 0 0 0-.05-.358 6.937 6.937 0 0 0-2.268.358Z"
              fill="#7e59d1"
            />
            <path
              data-name="Path 10680"
              d="M6.351 2.259a.293.293 0 0 1-.284.354H3.19a.581.581 0 0 1-.581-.581v-.156a1 1 0 0 0-.29.737.853.853 0 0 0 .871.871h4.358v-.581a5.193 5.193 0 0 0-1.258-.852 1.391 1.391 0 0 1 .06.208Z"
              fill="#7e59d1"
            />
            <path
              data-name="Path 10681"
              d="M15.097 2.613h-2.874a.293.293 0 0 1-.285-.354 1.361 1.361 0 0 1 .136-.372 5.437 5.437 0 0 0-1.622 1.017v.58h4.355a.853.853 0 0 0 .871-.871 1.137 1.137 0 0 0-.052-.343.581.581 0 0 1-.529.343Z"
              fill="#7e59d1"
            />
            <path
              data-name="Path 10682"
              d="M14.225 9.087v-5.6h-.581v5.6a.372.372 0 0 0 .581 0Z"
              fill="#7e59d1"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const dateIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="25"
    height="25"
    viewBox="0 0 25 25"
  >
    <defs>
      <clipPath id="clip-path-dateIcon">
        <rect
          id="Rectangle_512"
          data-name="Rectangle 512"
          width="25"
          height="25"
          transform="translate(105 2283)"
          fill="#7e59d1"
          stroke="#707070"
          strokeWidth="1"
        />
      </clipPath>
    </defs>
    <g
      id="Mask_Group_17"
      data-name="Mask Group 17"
      transform="translate(-105 -2283)"
      clipPath="url(#clip-path-dateIcon)"
    >
      <g
        id="svgexport-6_25_"
        data-name="svgexport-6 (25)"
        transform="translate(105 2283)"
      >
        <g id="Group_1005" data-name="Group 1005">
          <path
            id="Path_5150"
            data-name="Path 5150"
            d="M5.938.469a.783.783,0,0,0-.781.781v.781H2.813A2.35,2.35,0,0,0,.469,4.375v18.75a2.3,2.3,0,0,0,2.344,2.344H23.125a2.3,2.3,0,0,0,2.344-2.344V4.375a2.3,2.3,0,0,0-2.344-2.344H20.781V1.25a.781.781,0,0,0-1.562,0v.781H6.719V1.25A.738.738,0,0,0,5.938.469ZM23.906,23.125a.738.738,0,0,1-.781.781H2.813a.738.738,0,0,1-.781-.781V8.281H23.906ZM19.219,3.594v.781a.781.781,0,0,0,1.563,0V3.594h2.344a.738.738,0,0,1,.781.781V6.719H2.031V4.375a.738.738,0,0,1,.781-.781H5.156v.781a.738.738,0,0,0,.781.781.738.738,0,0,0,.781-.781V3.594Z"
            transform="translate(-0.469 -0.469)"
            fill="#7e59d1"
          />
          <path
            id="Path_5151"
            data-name="Path 5151"
            d="M3.641,11.016H6.766a.738.738,0,0,0,.781-.781V7.109a.738.738,0,0,0-.781-.781H3.641a.738.738,0,0,0-.781.781v3.125A.738.738,0,0,0,3.641,11.016Zm.781-3.125H5.984V9.453H4.422Z"
            transform="translate(1.125 3.438)"
            fill="#7e59d1"
          />
          <path
            id="Path_5152"
            data-name="Path 5152"
            d="M7.391,11.016h3.125a.738.738,0,0,0,.781-.781V7.109a.738.738,0,0,0-.781-.781H7.391a.738.738,0,0,0-.781.781v3.125A.738.738,0,0,0,7.391,11.016Zm.781-3.125H9.734V9.453H8.172Z"
            transform="translate(3.625 3.438)"
            fill="#7e59d1"
          />
          <path
            id="Path_5153"
            data-name="Path 5153"
            d="M11.141,11.016h3.125a.738.738,0,0,0,.781-.781V7.109a.738.738,0,0,0-.781-.781H11.141a.738.738,0,0,0-.781.781v3.125A.738.738,0,0,0,11.141,11.016Zm.781-3.125h1.563V9.453H11.922Z"
            transform="translate(6.125 3.438)"
            fill="#7e59d1"
          />
          <path
            id="Path_5154"
            data-name="Path 5154"
            d="M3.641,15.234H6.766a.738.738,0,0,0,.781-.781V11.328a.738.738,0,0,0-.781-.781H3.641a.738.738,0,0,0-.781.781v3.125A.738.738,0,0,0,3.641,15.234Zm.781-3.125H5.984v1.563H4.422Z"
            transform="translate(1.125 6.25)"
            fill="#7e59d1"
          />
          <path
            id="Path_5155"
            data-name="Path 5155"
            d="M7.391,15.234h3.125a.738.738,0,0,0,.781-.781V11.328a.738.738,0,0,0-.781-.781H7.391a.738.738,0,0,0-.781.781v3.125A.738.738,0,0,0,7.391,15.234Zm.781-3.125H9.734v1.563H8.172Z"
            transform="translate(3.625 6.25)"
            fill="#7e59d1"
          />
          <path
            id="Path_5156"
            data-name="Path 5156"
            d="M11.141,15.234h3.125a.738.738,0,0,0,.781-.781V11.328a.738.738,0,0,0-.781-.781H11.141a.738.738,0,0,0-.781.781v3.125A.738.738,0,0,0,11.141,15.234Zm.781-3.125h1.563v1.563H11.922Z"
            transform="translate(6.125 6.25)"
            fill="#7e59d1"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const courseLength = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="25"
    height="25"
    viewBox="0 0 25 25"
  >
    <defs>
      <clipPath id="clip-path-courseLength">
        <rect
          id="Rectangle_512"
          data-name="Rectangle 512"
          width="25"
          height="25"
          transform="translate(490 334)"
          fill="#7e59d1"
          stroke="#707070"
          strokeWidth="1"
        />
      </clipPath>
    </defs>
    <g
      id="Mask_Group_454"
      data-name="Mask Group 454"
      transform="translate(-490 -334)"
      clipPath="url(#clip-path-courseLength)"
    >
      <g
        id="svgexport-6_94_"
        data-name="svgexport-6 (94)"
        transform="translate(489.597 333.597)"
      >
        <g id="Group_10765" data-name="Group 10765">
          <path
            id="Path_10690"
            data-name="Path 10690"
            d="M21.977,17.8l-4.839-2.823a.4.4,0,0,0-.606.348v5.645a.4.4,0,0,0,.606.348l4.839-2.823a.4.4,0,0,0,0-.7Zm-4.639,2.469V16.025l3.635,2.121Z"
            fill="#7e59d1"
          />
          <path
            id="Path_10691"
            data-name="Path 10691"
            d="M22.984,1.21H2.823A2.422,2.422,0,0,0,.4,3.629v12.9a2.422,2.422,0,0,0,2.419,2.419h7.185l-.269,1.613H9.677a1.21,1.21,0,1,0,0,2.419H14.7a6.425,6.425,0,0,0,10.619-5.835,2.424,2.424,0,0,0,.085-.616V3.629A2.422,2.422,0,0,0,22.984,1.21ZM1.21,16.532v-.806H12.975a6.409,6.409,0,0,0-.475,2.419H2.823A1.615,1.615,0,0,1,1.21,16.532Zm20.41-4.254a1.208,1.208,0,1,0-2.265-.585c0,.007,0,.014,0,.021-.135-.008-.268-.021-.4-.021a6.413,6.413,0,0,0-.806.056V9.677h4.839v3.44A6.462,6.462,0,0,0,21.619,12.278Zm-1.439-.464a.4.4,0,1,1,.667.165A6.415,6.415,0,0,0,20.18,11.814Zm-5.664-.121a.4.4,0,1,1,.4.4A.4.4,0,0,1,14.516,11.694Zm-.4,2.016a.795.795,0,0,1,1.04-.768,6.5,6.5,0,0,0-1.04.95Zm1.813-1.259-.044-.032a1.2,1.2,0,0,0,.248-.725,1.21,1.21,0,0,0-2.419,0,1.2,1.2,0,0,0,.25.728,1.606,1.606,0,0,0-.653,1.288v1.21H12.5V9.677h4.839v2.229a6.405,6.405,0,0,0-1.413.545Zm-1.41-6.806a.4.4,0,1,1,.4.4A.4.4,0,0,1,14.516,5.645Zm-.4,2.016a.806.806,0,1,1,1.613,0v1.21H14.113Zm6.048-2.016a.4.4,0,1,1,.4.4A.4.4,0,0,1,20.161,5.645Zm-.4,2.016a.806.806,0,0,1,1.613,0v1.21H19.758Zm3.226,1.21h-.806V7.661a1.606,1.606,0,0,0-.653-1.288,1.2,1.2,0,0,0,.25-.728,1.21,1.21,0,1,0-2.419,0,1.2,1.2,0,0,0,.25.728,1.606,1.606,0,0,0-.653,1.288v1.21h-.806V3.629h4.839Zm-5.645,0h-.806V7.661a1.606,1.606,0,0,0-.653-1.288,1.2,1.2,0,0,0,.25-.728,1.21,1.21,0,1,0-2.419,0,1.2,1.2,0,0,0,.25.728,1.606,1.606,0,0,0-.653,1.288v1.21H12.5V3.629h4.839Zm-5.645,6.048H2.823V3.629h8.871Zm-.868,4.032h1.731a6.384,6.384,0,0,0,.419,1.613H10.556ZM9.274,21.774a.4.4,0,0,1,.4-.4h3.7a6.494,6.494,0,0,0,.55.806H9.677a.4.4,0,0,1-.4-.4Zm9.677,2.016A5.645,5.645,0,1,1,24.6,18.145,5.651,5.651,0,0,1,18.952,23.79Zm4.839-9.9V3.226a.4.4,0,0,0-.4-.4H2.419a.4.4,0,0,0-.4.4V14.919H1.21V3.629A1.615,1.615,0,0,1,2.823,2.016H22.984A1.615,1.615,0,0,1,24.6,3.629v11.4A6.462,6.462,0,0,0,23.79,13.892Z"
            fill="#7e59d1"
          />
          <path
            id="Path_10692"
            data-name="Path 10692"
            d="M4.032,13.306h6.452a.4.4,0,0,0,.4-.4V12.1A3.633,3.633,0,0,0,8.62,8.735a2.016,2.016,0,1,0-2.723,0A3.633,3.633,0,0,0,3.629,12.1V12.9a.4.4,0,0,0,.4.4ZM6.048,7.258a1.21,1.21,0,1,1,1.21,1.21A1.211,1.211,0,0,1,6.048,7.258ZM4.435,12.1a2.823,2.823,0,0,1,5.645,0v.4H4.435Z"
            fill="#7e59d1"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const clockIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="25"
    height="25"
    viewBox="0 0 25 25"
  >
    <defs>
      <clipPath id="clip-path-clockIcon">
        <rect
          id="Rectangle_512"
          data-name="Rectangle 512"
          width="25"
          height="25"
          transform="translate(693 334)"
          fill="#7e59d1"
          stroke="#707070"
          strokeWidth="1"
        />
      </clipPath>
    </defs>
    <g
      id="Mask_Group_455"
      data-name="Mask Group 455"
      transform="translate(-693 -334)"
      clipPath="url(#clip-path-clockIcon)"
    >
      <g
        id="svgexport-6_95_"
        data-name="svgexport-6 (95)"
        transform="translate(691.864 332.864)"
      >
        <path
          id="Path_10693"
          data-name="Path 10693"
          d="M25.153,8.77a12.5,12.5,0,1,0,0,9.732,12.533,12.533,0,0,0,0-9.732ZM13.636,23.863A10.227,10.227,0,1,1,23.863,13.636,10.239,10.239,0,0,1,13.636,23.863Z"
          fill="#7e59d1"
        />
        <path
          id="Path_10694"
          data-name="Path 10694"
          d="M14.772,13.165V6.818a1.136,1.136,0,0,0-2.272,0v6.818a1.134,1.134,0,0,0,.333.8l3.409,3.409a1.136,1.136,0,1,0,1.607-1.607Z"
          fill="#7e59d1"
        />
      </g>
    </g>
  </svg>
);

export const playVideo = (
  <svg
    id="Group_10713"
    data-name="Group 10713"
    xmlns="http://www.w3.org/2000/svg"
    width="65.705"
    height="65.705"
    viewBox="0 0 65.705 65.705"
    className="playVideo"
  >
    <path
      id="Path_5391"
      data-name="Path 5391"
      d="M22,0A22,22,0,1,1,0,22,22,22,0,0,1,22,0Z"
      transform="translate(10.853 12.852)"
      fill="#fff"
    />
    <g id="svgexport-6_15_" data-name="svgexport-6 (15)">
      <g id="Group_731" data-name="Group 731">
        <g id="Group_730" data-name="Group 730">
          <path
            id="Path_4677"
            data-name="Path 4677"
            d="M32.852,0A32.852,32.852,0,1,0,65.7,32.852,32.852,32.852,0,0,0,32.852,0ZM46.688,33.9a2.347,2.347,0,0,1-1.053,1.053v.012L26.861,44.351a2.347,2.347,0,0,1-3.4-2.112V23.466a2.347,2.347,0,0,1,3.4-2.1l18.773,9.386A2.346,2.346,0,0,1,46.688,33.9Z"
            fill="#393939"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const liveSessionIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="15"
    height="15"
    viewBox="0 0 15 15"
  >
    <defs>
      <clipPath id="clip-path-liveSessionIcon">
        <rect
          id="Rectangle_27335"
          data-name="Rectangle 27335"
          width="15"
          height="15"
          transform="translate(131 1542)"
          fill="#6a6f73"
          stroke="#707070"
          strokeWidth="1"
        />
      </clipPath>
    </defs>
    <g
      id="Mask_Group_447"
      data-name="Mask Group 447"
      transform="translate(-131 -1542)"
      clipPath="url(#clip-path-liveSessionIcon)"
    >
      <g
        id="svgexport-6_76_"
        data-name="svgexport-6 (76)"
        transform="translate(131 1542)"
      >
        <g id="Live_1_">
          <path
            id="Path_10619"
            data-name="Path 10619"
            d="M13.682,7.09H1.318A1.32,1.32,0,0,0,0,8.408v5.273A1.32,1.32,0,0,0,1.318,15H13.682A1.32,1.32,0,0,0,15,13.682V8.408A1.32,1.32,0,0,0,13.682,7.09Zm-9.7,6.152H2.227a.439.439,0,0,1-.439-.439V9.287a.439.439,0,1,1,.879,0v3.076H3.984a.439.439,0,0,1,0,.879Zm2.2-.439a.439.439,0,1,1-.879,0V9.287a.439.439,0,1,1,.879,0Zm3.5-3.409-.879,3.516a.439.439,0,0,1-.852,0L7.074,9.394a.439.439,0,0,1,.852-.213l.453,1.81.453-1.81a.439.439,0,0,1,.852.213Zm3.089,1.212a.439.439,0,1,1,0,.879H11.455v.879h1.318a.439.439,0,0,1,0,.879H11.016a.439.439,0,0,1-.439-.439V9.287a.439.439,0,0,1,.439-.439h1.758a.439.439,0,0,1,0,.879H11.455v.879Z"
            fill="#6a6f73"
          />
          <g id="Group_10483" data-name="Group 10483">
            <path
              id="Path_10620"
              data-name="Path 10620"
              d="M3.632,5.977a4.855,4.855,0,0,1,0-5.8.44.44,0,0,1,.7.528,3.971,3.971,0,0,0,0,4.746.44.44,0,1,1-.7.528Z"
              fill="#6a6f73"
            />
          </g>
          <g id="Group_10484" data-name="Group 10484">
            <path
              id="Path_10621"
              data-name="Path 10621"
              d="M10.752,6.064a.44.44,0,0,1-.088-.615,3.971,3.971,0,0,0,0-4.746.44.44,0,1,1,.7-.528,4.855,4.855,0,0,1,0,5.8.44.44,0,0,1-.615.088Z"
              fill="#6a6f73"
            />
          </g>
          <g id="Group_10485" data-name="Group 10485">
            <path
              id="Path_10622"
              data-name="Path 10622"
              d="M5.207,5.127a3.071,3.071,0,0,1,0-4.1.439.439,0,1,1,.655.586,2.193,2.193,0,0,0,0,2.929.439.439,0,0,1-.655.586Z"
              fill="#6a6f73"
            />
          </g>
          <g id="Group_10486" data-name="Group 10486">
            <path
              id="Path_10623"
              data-name="Path 10623"
              d="M9.172,5.161a.44.44,0,0,1-.034-.621,2.193,2.193,0,0,0,0-2.929.439.439,0,0,1,.655-.586,3.071,3.071,0,0,1,0,4.1.44.44,0,0,1-.621.034Z"
              fill="#6a6f73"
            />
          </g>
          <g id="Group_10487" data-name="Group 10487">
            <path
              id="Path_10624"
              data-name="Path 10624"
              d="M7.5,4.395A1.318,1.318,0,1,1,8.818,3.076,1.32,1.32,0,0,1,7.5,4.395Z"
              fill="#6a6f73"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const sessionDateIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="14"
    height="14"
    viewBox="0 0 14 14"
  >
    <defs>
      <clipPath id="clip-path-sessionDateIcon">
        <rect
          id="Rectangle_512"
          data-name="Rectangle 512"
          width="14"
          height="14"
          transform="translate(105 2283)"
          fill="#2a2a2a"
          stroke="#707070"
          strokeWidth="1"
        />
      </clipPath>
    </defs>
    <g
      id="Mask_Group_17"
      data-name="Mask Group 17"
      transform="translate(-105 -2283)"
      clipPath="url(#clip-path-sessionDateIcon)"
    >
      <g
        id="svgexport-6_25_"
        data-name="svgexport-6 (25)"
        transform="translate(105 2283)"
      >
        <g id="Group_1005" data-name="Group 1005">
          <path
            id="Path_5150"
            data-name="Path 5150"
            d="M3.531.469a.438.438,0,0,0-.437.438v.438H1.781A1.316,1.316,0,0,0,.469,2.656v10.5a1.289,1.289,0,0,0,1.313,1.313H13.156a1.289,1.289,0,0,0,1.313-1.312V2.656a1.289,1.289,0,0,0-1.312-1.312H11.844V.906a.438.438,0,0,0-.875,0v.438h-7V.906A.413.413,0,0,0,3.531.469ZM13.594,13.156a.413.413,0,0,1-.437.438H1.781a.413.413,0,0,1-.437-.437V4.844h12.25ZM10.969,2.219v.438a.438.438,0,0,0,.875,0V2.219h1.313a.413.413,0,0,1,.438.438V3.969H1.344V2.656a.413.413,0,0,1,.438-.437H3.094v.438a.413.413,0,0,0,.438.438.413.413,0,0,0,.438-.437V2.219Z"
            transform="translate(-0.469 -0.469)"
            fill="#2a2a2a"
          />
          <path
            id="Path_5151"
            data-name="Path 5151"
            d="M3.3,8.953h1.75a.413.413,0,0,0,.438-.437V6.766a.413.413,0,0,0-.437-.437H3.3a.413.413,0,0,0-.437.438v1.75A.413.413,0,0,0,3.3,8.953ZM3.734,7.2h.875v.875H3.734Z"
            transform="translate(-0.628 -0.859)"
            fill="#2a2a2a"
          />
          <path
            id="Path_5152"
            data-name="Path 5152"
            d="M7.047,8.953H8.8a.413.413,0,0,0,.438-.437V6.766A.413.413,0,0,0,8.8,6.328H7.047a.413.413,0,0,0-.437.438v1.75A.413.413,0,0,0,7.047,8.953ZM7.484,7.2h.875v.875H7.484Z"
            transform="translate(-0.878 -0.859)"
            fill="#2a2a2a"
          />
          <path
            id="Path_5153"
            data-name="Path 5153"
            d="M10.8,8.953h1.75a.413.413,0,0,0,.438-.437V6.766a.413.413,0,0,0-.437-.437H10.8a.413.413,0,0,0-.437.438v1.75A.413.413,0,0,0,10.8,8.953Zm.438-1.75h.875v.875h-.875Z"
            transform="translate(-1.128 -0.859)"
            fill="#2a2a2a"
          />
          <path
            id="Path_5154"
            data-name="Path 5154"
            d="M3.3,13.172h1.75a.413.413,0,0,0,.438-.437v-1.75a.413.413,0,0,0-.437-.437H3.3a.413.413,0,0,0-.437.438v1.75A.413.413,0,0,0,3.3,13.172Zm.438-1.75h.875V12.3H3.734Z"
            transform="translate(-0.628 -1.141)"
            fill="#2a2a2a"
          />
          <path
            id="Path_5155"
            data-name="Path 5155"
            d="M7.047,13.172H8.8a.413.413,0,0,0,.438-.437v-1.75a.413.413,0,0,0-.437-.437H7.047a.413.413,0,0,0-.437.438v1.75A.413.413,0,0,0,7.047,13.172Zm.438-1.75h.875V12.3H7.484Z"
            transform="translate(-0.878 -1.141)"
            fill="#2a2a2a"
          />
          <path
            id="Path_5156"
            data-name="Path 5156"
            d="M10.8,13.172h1.75a.413.413,0,0,0,.438-.437v-1.75a.413.413,0,0,0-.437-.437H10.8a.413.413,0,0,0-.437.438v1.75A.413.413,0,0,0,10.8,13.172Zm.438-1.75h.875V12.3h-.875Z"
            transform="translate(-1.128 -1.141)"
            fill="#2a2a2a"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const sessionTimeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="14"
    height="14"
    viewBox="0 0 14 14"
  >
    <defs>
      <clipPath id="clip-path-sessionTimeIcon">
        <rect
          id="Rectangle_513"
          data-name="Rectangle 513"
          width="14"
          height="14"
          transform="translate(245 2286)"
          fill="#2a2a2a"
          stroke="#707070"
          strokeWidth="1"
        />
      </clipPath>
    </defs>
    <g
      id="Mask_Group_18"
      data-name="Mask Group 18"
      transform="translate(-245 -2286)"
      clipPath="url(#clip-path-sessionTimeIcon)"
    >
      <g
        id="svgexport-6_26_"
        data-name="svgexport-6 (26)"
        transform="translate(245 2286)"
      >
        <path
          id="Path_5157"
          data-name="Path 5157"
          d="M7.545.545a7,7,0,1,0,7,7,7,7,0,0,0-7-7Zm0,12.727a5.727,5.727,0,1,1,5.727-5.727A5.727,5.727,0,0,1,7.545,13.273Z"
          transform="translate(-0.545 -0.545)"
          fill="#2a2a2a"
        />
        <path
          id="Path_5158"
          data-name="Path 5158"
          d="M7.273,6.918V3.364A.636.636,0,0,0,6,3.364V7.182a.636.636,0,0,0,.186.45L8.1,9.541a.636.636,0,1,0,.9-.9Z"
          transform="translate(0.364 -0.182)"
          fill="#2a2a2a"
        />
      </g>
    </g>
  </svg>
);

export const cartCertificate = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g data-name="Mask Group 450">
      <g data-name="svgexport-6 (85)">
        <g data-name="008---Certificate" fill="#6a6f73" stroke="#6a6f73">
          <path d="M14.667 1.067H1.333A1.335 1.335 0 0 0 0 2.4V12a1.335 1.335 0 0 0 1.333 1.333h8v1.334a.267.267 0 0 0 .455.189l.878-.878.878.878a.267.267 0 0 0 .456-.189v-1.333h2.667A1.335 1.335 0 0 0 16 12V2.4a1.335 1.335 0 0 0-1.333-1.333ZM8.616 6.284a.142.142 0 0 1-.045-.225.678.678 0 0 0 0-.918.142.142 0 0 1 .045-.225.678.678 0 0 0 .351-.849.142.142 0 0 1 .127-.191.678.678 0 0 0 .649-.649.142.142 0 0 1 .191-.127.68.68 0 0 0 .848-.351.141.141 0 0 1 .225-.045.678.678 0 0 0 .918 0 .142.142 0 0 1 .225.045.679.679 0 0 0 .85.352.142.142 0 0 1 .191.127.679.679 0 0 0 .65.649.142.142 0 0 1 .126.19.678.678 0 0 0 .351.848.142.142 0 0 1 .045.225.678.678 0 0 0 0 .918.142.142 0 0 1-.045.225.678.678 0 0 0-.351.848.142.142 0 0 1-.127.191.678.678 0 0 0-.65.65.142.142 0 0 1-.19.129.679.679 0 0 0-.848.351.137.137 0 0 1-.1.08.14.14 0 0 1-.124-.035.678.678 0 0 0-.918 0 .14.14 0 0 1-.124.035.138.138 0 0 1-.1-.08.678.678 0 0 0-.848-.351.142.142 0 0 1-.191-.127.679.679 0 0 0-.65-.651.142.142 0 0 1-.127-.191.678.678 0 0 0-.35-.848Zm2.929 4.994-.078.078V8.85a.141.141 0 0 1 .1.038.667.667 0 0 0 .456.18.7.7 0 0 0 .135-.013.667.667 0 0 0 .48-.38.142.142 0 0 1 .178-.074.674.674 0 0 0 .253.038v2.718l-.611-.611a.267.267 0 0 0-.377 0Zm-.078 2.745-.611-.611a.267.267 0 0 0-.377 0l-.611.611V8.638a.674.674 0 0 0 .253-.038.142.142 0 0 1 .178.073.667.667 0 0 0 .482.381.7.7 0 0 0 .152.013V12a.267.267 0 0 0 .455.189l.078-.078Zm4-2.023a.8.8 0 0 1-.8.8H12v-1.223l.267-.267.878.878a.267.267 0 0 0 .455-.189v-3.65a.663.663 0 0 0 .122-.357.143.143 0 0 1 .137-.136.675.675 0 0 0 .607-.909.142.142 0 0 1 .074-.18.675.675 0 0 0 .213-1.073.142.142 0 0 1 0-.193.675.675 0 0 0-.213-1.072.142.142 0 0 1-.074-.178.675.675 0 0 0-.607-.909.143.143 0 0 1-.137-.136.675.675 0 0 0-.909-.608.141.141 0 0 1-.178-.073.675.675 0 0 0-1.073-.213.142.142 0 0 1-.193 0 .675.675 0 0 0-1.069.215.142.142 0 0 1-.178.074.675.675 0 0 0-.909.608.143.143 0 0 1-.137.136.675.675 0 0 0-.607.909.142.142 0 0 1-.074.178.675.675 0 0 0-.215 1.072.142.142 0 0 1 0 .193.675.675 0 0 0 .213 1.07.142.142 0 0 1 .074.178.675.675 0 0 0 .607.909.143.143 0 0 1 .137.136.663.663 0 0 0 .122.356v4.451h-8a.8.8 0 0 1-.8-.8v-9.6a.8.8 0 0 1 .8-.8h13.334a.8.8 0 0 1 .8.8Z" />
          <path
            data-name="Shape"
            d="M2.933 10.667a.8.8 0 0 1-.8-.8V4.534a.8.8 0 0 1 .8-.8h4.8a.267.267 0 0 0 0-.533h-4.8A1.335 1.335 0 0 0 1.6 4.534v5.333A1.335 1.335 0 0 0 2.933 11.2H8a.267.267 0 1 0 0-.533Z"
          />
          <path
            data-name="Shape"
            d="M3.2 7.467h3.733a.267.267 0 1 0 0-.533H3.2a.267.267 0 1 0 0 .533ZM3.2 6.4h3.733a.267.267 0 1 0 0-.533H3.2a.267.267 0 0 0 0 .533ZM3.2 5.334h3.733a.267.267 0 1 0 0-.533H3.2a.267.267 0 0 0 0 .533ZM2.955 9.974a.267.267 0 0 0 .245.16.262.262 0 0 0 .107-.022 2.05 2.05 0 0 0 .668-.408 1.253 1.253 0 0 0 .188-.24 1.421 1.421 0 0 0 .354.288.722.722 0 0 0 .626.08.6.6 0 0 0 .213-.141 1.219 1.219 0 0 0 .393.159l.2.048a4.19 4.19 0 0 0 1.27.169.267.267 0 1 0-.038-.532 3.682 3.682 0 0 1-1.105-.155l-.206-.049c-.249-.057-.313-.158-.339-.228a.267.267 0 0 0-.516.112.135.135 0 0 1-.059.12.246.246 0 0 1-.176-.045 1.093 1.093 0 0 1-.459-.58.267.267 0 0 0-.521.107.69.69 0 0 1-.206.509 1.582 1.582 0 0 1-.5.3.267.267 0 0 0-.138.351ZM11.467 7.734A2.133 2.133 0 1 0 9.333 5.6a2.133 2.133 0 0 0 2.134 2.134Zm0-3.733a1.6 1.6 0 1 1-1.6 1.6A1.6 1.6 0 0 1 11.467 4Z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const CheckedIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    style={{
      marginRight: '1rem',
    }}
  >
    <defs>
      <clipPath id="clip-path-CheckedIcon">
        <rect
          id="Rectangle_1383"
          data-name="Rectangle 1383"
          width="16"
          height="16"
          fill="#fff"
          stroke="#707070"
          strokeWidth="1"
        />
      </clipPath>
    </defs>
    <g
      id="Mask_Group_295"
      data-name="Mask Group 295"
      clipPath="url(#clip-path-emptyCircleIcon)"
    >
      <g
        id="svgexport-6_64_"
        data-name="svgexport-6 (64)"
        transform="translate(0 0.813)"
      >
        <g id="_30-Checked" data-name="30-Checked" transform="translate(1.828)">
          <path
            id="Path_7766"
            data-name="Path 7766"
            d="M7.521,14.817l-.155-.263C6.208,12.58,3.125,8.385,3.094,8.343L3,8.22,4.163,7.075,7.482,9.392A38.177,38.177,0,0,1,12.767,3.77,19.216,19.216,0,0,1,15.09,2.014l.042-.025h2.043L16.83,2.3c-4.37,3.892-9.11,12.172-9.158,12.255Z"
            transform="translate(-3.004 -1.989)"
            fill="#7e59d1"
          />
        </g>
        <g id="_13-Cancel" data-name="13-Cancel" transform="translate(0 1.669)">
          <circle
            id="Ellipse_640"
            data-name="Ellipse 640"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(6.065)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_641"
            data-name="Ellipse 641"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(6.065 12.143)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_642"
            data-name="Ellipse 642"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(0 6.072)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_643"
            data-name="Ellipse 643"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(12.13 6.072)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_644"
            data-name="Ellipse 644"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(1.772 10.365)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_645"
            data-name="Ellipse 645"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(1.776 1.783)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_646"
            data-name="Ellipse 646"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(10.354 10.36)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_647"
            data-name="Ellipse 647"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(0.807 3.036)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_648"
            data-name="Ellipse 648"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(11.323 9.107)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_649"
            data-name="Ellipse 649"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(3.033 11.324)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_650"
            data-name="Ellipse 650"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(4.494 0.207)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_651"
            data-name="Ellipse 651"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(7.636 11.936)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_652"
            data-name="Ellipse 652"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(0.207 7.641)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_653"
            data-name="Ellipse 653"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(11.923 4.502)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_654"
            data-name="Ellipse 654"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(0.807 9.107)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_655"
            data-name="Ellipse 655"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(9.098 11.324)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_656"
            data-name="Ellipse 656"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(3.033 0.819)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_657"
            data-name="Ellipse 657"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(7.636 0.207)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_658"
            data-name="Ellipse 658"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(4.494 11.936)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_659"
            data-name="Ellipse 659"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(11.923 7.641)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
          <circle
            id="Ellipse_660"
            data-name="Ellipse 660"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(0.207 4.502)"
            fill="#7e59d1"
            stroke="#7e59d1"
            strokeWidth="0.2"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const emptyCircleIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    style={{
      marginRight: '1rem',
    }}
  >
    <defs>
      <clipPath id="clip-path-emptyCircleIcon">
        <rect
          id="Rectangle_1385"
          data-name="Rectangle 1385"
          width="16"
          height="16"
          fill="#fff"
          stroke="#707070"
          strokeWidth="1"
        />
      </clipPath>
    </defs>
    <g
      id="Mask_Group_297"
      data-name="Mask Group 297"
      clipPath="url(#clip-path-emptyCircleIcon)"
    >
      <g
        id="svgexport-6_64_"
        data-name="svgexport-6 (64)"
        transform="translate(0 2.482)"
      >
        <g id="_13-Cancel" data-name="13-Cancel">
          <circle
            id="Ellipse_682"
            data-name="Ellipse 682"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(6.065)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_683"
            data-name="Ellipse 683"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(6.065 12.143)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_684"
            data-name="Ellipse 684"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(0 6.072)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_685"
            data-name="Ellipse 685"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(12.13 6.072)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_686"
            data-name="Ellipse 686"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(1.772 10.365)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_687"
            data-name="Ellipse 687"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(1.776 1.783)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_688"
            data-name="Ellipse 688"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(10.354 10.36)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_689"
            data-name="Ellipse 689"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(0.807 3.036)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_690"
            data-name="Ellipse 690"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(11.323 9.107)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_691"
            data-name="Ellipse 691"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(3.033 11.324)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_692"
            data-name="Ellipse 692"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(4.494 0.207)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_693"
            data-name="Ellipse 693"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(7.636 11.936)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_694"
            data-name="Ellipse 694"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(0.207 7.641)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_695"
            data-name="Ellipse 695"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(11.923 4.502)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_696"
            data-name="Ellipse 696"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(0.807 9.107)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_697"
            data-name="Ellipse 697"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(9.098 11.324)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_698"
            data-name="Ellipse 698"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(3.033 0.819)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_699"
            data-name="Ellipse 699"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(7.636 0.207)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_700"
            data-name="Ellipse 700"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(4.494 11.936)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_701"
            data-name="Ellipse 701"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(11.923 7.641)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
          <circle
            id="Ellipse_702"
            data-name="Ellipse 702"
            cx="0.281"
            cy="0.281"
            r="0.281"
            transform="translate(0.207 4.502)"
            fill="#6a6f73"
            stroke="#6a6f73"
            strokeWidth="0.3"
          />
        </g>
      </g>
    </g>
  </svg>
);
